"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iconStyles = exports.accordionExpandIconColor = exports.highlightBackgroundColor = void 0;
const types_1 = require("../../types");
exports.highlightBackgroundColor = {
    [types_1.BusinessUnit.BOT]: 'rgba(169, 203, 122, 0.3)',
    [types_1.BusinessUnit.EUD]: 'rgba(169, 136, 98, 0.4)',
    [types_1.BusinessUnit.EAM]: '#D7C6E3',
    [types_1.BusinessUnit.OUI]: '#E6D6CE',
    [types_1.BusinessUnit.MLT]: '#F6F6F6',
};
exports.accordionExpandIconColor = {
    [types_1.BusinessUnit.BOT]: '#499D71',
    [types_1.BusinessUnit.EUD]: '#A98862',
    [types_1.BusinessUnit.EAM]: '#9174E4',
    [types_1.BusinessUnit.OUI]: '#971B2F',
    [types_1.BusinessUnit.MLT]: '#F6F6F6',
};
exports.iconStyles = {
    color: '#000000',
};
